(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentInfoDialogController', TkbPaymentInfoDialogController);

    TkbPaymentInfoDialogController.$inject = ['$uibModalInstance', 'entity'];

    function TkbPaymentInfoDialogController($uibModalInstance, entity) {
        var vm = this;
        vm.payment = entity;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
